<template>
  <div id="app">
    <router-view />
    <mobile-app-gate />
  </div>
</template>

<script>
import "@/assets/site/css/govava.min.css";
import "@/assets/site/css/styles-l.min.css";
import "@/assets/site/css/config_default.css";
import "@/assets/site/css/custom.css";
import MobileAppGate from "@/components/MobileAppGate.vue";

export default {
  name: "App",
  components: {
    MobileAppGate,
  },
};
</script>